module.exports = __webpack_public_path__ + "static/Icons-795d17777c99412ba6d80f6e5b4abbac.svg";